
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/asset/stock",
      function () {
        return require("private-next-pages/asset/stock.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/asset/stock"])
      });
    }
  